module.exports = __webpack_public_path__ + "e2247222d3693df973e69a45422864b0.svg";